import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    formData.delete('phone_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9mvvle8mbnljin59sbg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};

      try {
        parsed = JSON.parse(responseText);
      } catch {
        // use raw responseText
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === 'string' && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'));

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，您将第一时间收到日韩在线的最新资讯。');
        setEmail('');
      } else if (isSpam || !response.ok || parsed?.code !== 'OK') {
        setStatus('error');
        setMessage(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试。');
    }
  };

  return (
    <section className="w-full bg-accent-500 py-14 md:py-20">
      <div className="max-w-[600px] mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-background-50/20">
          <i className="ri-mail-send-line text-2xl text-background-50"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 dark:text-foreground-950 mb-3">
          订阅日韩在线资讯
        </h2>
        <p className="text-sm text-background-50/80 dark:text-foreground-950/80 mb-8">
          第一时间获取日韩最新影视动态、新番推荐和独家内容更新通知
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form=""
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full text-sm bg-background-50 text-foreground-900 placeholder:text-foreground-400 outline-none"
          />
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <button
            type="submit"
            className="bg-background-50 dark:bg-foreground-950 text-accent-600 dark:text-accent-400 px-6 py-3 rounded-full text-sm font-bold whitespace-nowrap hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          >
            立即订阅
          </button>
        </form>

        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-background-50 dark:text-foreground-950' : 'text-background-50/90 dark:text-foreground-950/90'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}